document.addEventListener("DOMContentLoaded", function () {

  const wrapperFeatured = document.querySelector('product-recommendations');
  const useMutation = document.querySelector('[data-observe="true"]')

  const executeLogic = () => {

    const forms = document.querySelectorAll('form[data-type="go-to-checkout-form"]');

    const cartNotification = document.querySelector(".cart-notification");
    const cartDrawer = document.querySelector(".drawer");

    const disableActive = (elementToDisabled) => {
      elementToDisabled.setAttribute("hidden", "");
    };

    forms.forEach(function (form) {
      form.addEventListener("submit", async (e) => {
        e.preventDefault();

        if (cartNotification) disableActive(cartNotification);
        if (cartDrawer) disableActive(cartDrawer);

        const { productId, variantId } = form.dataset;
        const qty = 1;

        try {
          const resulFetch = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              id: variantId,
              quantity: qty,
            }),
          });

          const { status } = await resulFetch.json();
          if (status == 422) {
            // error
          } else {
            window.location.href = "/checkout";
          }
        } catch (error) {
          //set display error
        }
      });
    });
  }

  if(useMutation){
   
    const observe = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {   
        if(mutation.attributeName === 'class'){
          if(mutation.target.classList.contains('product-recommendations--loaded')){
            executeLogic();
            observe.disconnect();
          }
        }
      })
    })

    observe.observe(wrapperFeatured, { attributes: true, childList: false, subtree: false });
  } else {
    executeLogic();
  }
});
